import consultoriasRotas from './consultorias/ConsultoriasRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'uabs',
    name: 'AppSebrae_Consultorias_Uabs',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [consultoriasRotas, pagamentosRotas]
}
